import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ListProduct} from 'components/list-product';
import title from 'constants/TitlePages.js';

class ListProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.ListProductPage;
  }

  render() {
    return (
      <MasterLayout hasBreadcrumb={true}>
        <ListProduct params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default ListProductPage;



// WEBPACK FOOTER //
// ./pages/list-product/ListProductPage.jsx